import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';



@Component({
  selector: 'prime-button',
  standalone: true,
  imports: [
    ButtonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './prime-button.component.html',
  styleUrl: './prime-button.component.scss'
})
export class PrimeButtonComponent {
  label = input<string>();
  type = input<'button' | 'submit'>('button');
  disabled = input(false);
  classes = input<string>();

  /** Señales para cambiar la visualización del button */
  raised = input(false);
  rounded = input(false);
  text = input(false);
  outlined = input(false);
  icon = input<string>();
  severity = input<'success' | 'info' | 'warning' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast'>('primary');
}
